(function () {
  'use strict';

  var CART_ADD_URL = '/cart/add.js';

  function $(selector, context) { return (context || document).querySelector(selector); }
  function $$(selector, context) { return Array.from((context || document).querySelectorAll(selector)); }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.voltaparcafabrikaMoneyFormat);
    }
    return (cents / 100).toFixed(2) + ' TL';
  }

  /* ── Toast ── */
  function showToast(message, type) {
    var toast = $('.vp-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'vp-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      var style = document.createElement('style');
      style.textContent = '.vp-toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(20px);background:#0f172a;color:#fff;padding:10px 20px;border-radius:6px;font-size:.875rem;font-weight:600;z-index:9000;opacity:0;transition:opacity .2s,transform .2s;pointer-events:none}.vp-toast.is-visible{opacity:1;transform:translateX(-50%) translateY(0)}.vp-toast.is-error{background:#b91c1c}';
      document.head.appendChild(style);
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.className = 'vp-toast' + (type === 'error' ? ' is-error' : '');
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
  }

  /* ── Cart Drawer ── */
  var Drawer = {
    el: function() { return document.getElementById('CartDrawer'); },
    open: function() {
      var d = this.el();
      if(d) {
        d.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    },
    close: function() {
      var d = this.el();
      if(d) {
        d.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    },
    refresh: function() {
      var d = this.el();
      if(!d) return;
      var sectionId = d.getAttribute('data-section-id');
      if(!sectionId) return;
      fetch('/?sections=' + sectionId)
        .then(function(r){ return r.json(); })
        .then(function(res){
          var html = res[sectionId];
          var div = document.createElement('div');
          div.innerHTML = html;
          var newDrawer = div.querySelector('#CartDrawer');
          if (newDrawer && d) {
            d.innerHTML = newDrawer.innerHTML;
            if (newDrawer.classList.contains('is-empty')) d.classList.add('is-empty');
            else d.classList.remove('is-empty');
          }
          Drawer.updateCount();
        });
    },
    updateCount: function() {
      fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
        var badge = document.querySelector('.voltaparcafabrika-header-main__cart-count');
        if (!badge) {
          var cartBtn = document.querySelector('.voltaparcafabrika-header-main__cart');
          if (cartBtn && cart.item_count > 0) {
            badge = document.createElement('span');
            badge.className = 'voltaparcafabrika-header-main__cart-count';
            cartBtn.appendChild(badge);
          }
        }
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        }
      });
    },
    updateItem: function(line, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function(){ Drawer.refresh(); });
    }
  };

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      Drawer.close();
    }
    var headerCartBtn = e.target.closest('.voltaparcafabrika-header-main__cart');
    if (headerCartBtn && headerCartBtn.getAttribute('href') === '/cart') {
      e.preventDefault();
      Drawer.refresh();
      Drawer.open();
    }
    var removeBtn = e.target.closest('.vp-cart-drawer__remove');
    if (removeBtn) {
      e.preventDefault();
      Drawer.updateItem(removeBtn.getAttribute('data-line'), 0);
    }
    var qtyBtn = e.target.closest('.vp-cart-drawer__qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      var input = qtyBtn.parentElement.querySelector('input');
      var line = qtyBtn.getAttribute('data-line');
      var val = parseInt(input.value, 10);
      var change = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      Drawer.updateItem(line, val + change);
    }
  });

  /* ── Add to cart ── */
  function addToCart(variantId, quantity, btn) {
    if (!variantId) return;
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '...'; }

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Hata'); });
        return r.json();
      })
      .then(function (cartItem) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "add_to_cart",
          ecommerce: {
            currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "TRY",
            value: cartItem.price ? cartItem.price / 100 : 0,
            items: [
              {
                item_id: cartItem.variant_id || variantId,
                item_name: cartItem.product_title || '',
                price: cartItem.price ? cartItem.price / 100 : 0,
                quantity: quantity || 1
              }
            ]
          }
        });
        document.dispatchEvent(new CustomEvent('voltaparcafabrika:cart:added'));
        Drawer.refresh();
        Drawer.open();
      })
      .catch(function (err) { showToast(err.message || 'Bir hata oluştu', 'error'); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
      });
  }

  /* ── Product card buttons (delegated) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-voltaparcafabrika-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.getAttribute('data-variant-id'), 1, btn);
  });

  /* ── Product page gallery (vp-* classes) ── */
  function initProductGallery() {
    var gallery = $('.vp-product-gallery');
    if (!gallery) return;

    var mainImg  = $('.vp-product-gallery__main img', gallery);
    var thumbs   = $$('.vp-product-gallery__thumb', gallery);
    if (!mainImg || !thumbs.length) return;

    var images = thumbs.map(function (t) { return t.querySelector('img'); });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var img = images[i];
        if (!img || !mainImg) return;
        mainImg.src    = img.src.replace(/width=\d+/, 'width=800');
        mainImg.srcset = '';
        thumbs.forEach(function (t) { t.classList.remove('vp-product-gallery__thumb--active'); });
        thumb.classList.add('vp-product-gallery__thumb--active');
      });
    });
  }

  /* ── Product page form ── */
  function initProductForm() {
    var form = $('form[data-product-form]');
    if (!form) return;

    var variantSelect = $('[data-variant-select]', form);
    var variantInput  = $('[name="id"]', form);
    var addBtn        = $('[data-voltaparcafabrika-add-to-cart]', form);
    var priceEl       = $('[data-product-price]');
    var compareEl     = $('[data-product-compare-price]');
    var stockEl       = $('[data-product-stock]');
    var productJson   = document.getElementById('voltaparcafabrika-product-json');
    if (!productJson) return;

    var productData;
    try { productData = JSON.parse(productJson.textContent); } catch (e) { return; }
    if (!productData || !productData.variants) return;

    function updateVariant(id) {
      var v = productData.variants.find(function (x) { return String(x.id) === String(id); });
      if (!v) return;
      if (variantInput) variantInput.value = v.id;
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', v.id);
        addBtn.disabled    = !v.available;
        addBtn.textContent = v.available
          ? (addBtn.getAttribute('data-label-available') || 'Sepete Ekle')
          : 'Tükendi';
      }
      if (priceEl)   priceEl.textContent   = formatMoney(v.price);
      if (compareEl) {
        compareEl.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
        compareEl.style.display = v.compare_at_price > v.price ? '' : 'none';
      }
      if (stockEl) {
        stockEl.textContent = v.available ? 'Stokta' : 'Tükendi';
        stockEl.className   = 'vp-product-info__stock ' +
          (v.available ? 'vp-product-info__stock--in' : 'vp-product-info__stock--out');
      }
      /* sticky bar */
      var stickyPrice = $('[data-sticky-price]');
      var stickyBtn   = $('[data-sticky-add]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (stickyBtn)   { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Sepete Ekle' : 'Tükendi'; }
      document.dispatchEvent(new CustomEvent('voltaparcafabrika:variant:change', { detail: { variant: v } }));
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', function () { updateVariant(variantSelect.value); });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = variantInput ? variantInput.value : (addBtn && addBtn.getAttribute('data-variant-id'));
      addToCart(id, 1, addBtn);
    });

    var init = variantInput ? variantInput.value : (productData.variants[0] && productData.variants[0].id);
    if (init) updateVariant(init);
  }

  /* ── Sticky bar visibility ── */
  function initStickyBar() {
    var bar  = $('.vp-sticky-bar');
    var form = $('form[data-product-form]');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.style.display = entries[0].isIntersecting ? 'none' : 'flex';
    }, { threshold: 0 }).observe(form);

    var stickyBtn = $('[data-sticky-add]', bar);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var addBtn = $('[data-voltaparcafabrika-add-to-cart]', form);
        if (addBtn && !addBtn.disabled) addBtn.click();
      });
    }
  }

  /* ── FAQ accordion ── */
  function initFaq() {
    $$('[data-vp-faq-trigger]').forEach(function (trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      var panel   = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;
      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        $$('[data-vp-faq-trigger]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = true;
        });
        if (!open) {
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  /* ── Init ── */
  function init() {
    initProductGallery();
    initProductForm();
    initStickyBar();
    initFaq();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
